export default __webpack_public_path__ + "static/media/Platform=Spotify.3e9dfe42.svg";